<template>
  <div class="add-to-offer__header">
    {{ __('make_an_offer') }}
  </div>
  <template v-if="!isLoggedIn">
    <p v-html="__('not_logged_in')"></p>
    <p class="text-center calculator-icon">
      <i class="fal fa-calculator" style="display: block; font-size: 160px; color: #ccc; margin-top: 60px;"></i>
    </p>
  </template>
  <form v-else>
    <div class="form-responsive">
      <div class="">
        <div class="form-group">
          <label for="">{{ __('assign_to') }}</label>
          <select v-model="offer" id="offer_id" name="offer_id" class="form-control form-control-sm with-arrow">
            <option value="new_offer">{{ __('create_new_offer') }}</option>
            <optgroup v-if="lastOffers.length>0" :label="__('last_offers')">
              <option v-for="offer in lastOffers" :value="offer.id">
                {{ offer.name }}
              </option>
            </optgroup>
            <optgroup :label="__('active_offers')">
              <option v-for="offer in data.offers" :value="offer.id">
                {{ offer.display_name }}
              </option>
            </optgroup>
          </select>
        </div>

        <div class="form-group">
          <label for="">{{ __('quantity') }}</label>
          <input type="text" v-model.lazy="qty" class="form-control form-control-sm">
        </div>

        <div class="form-group" v-if="data.boxes.length">
          <label for="">{{ __('boxes') }}</label>
          <select v-model="box" id="add-marking-item-select"
                  class="form-control form-control-sm with-arrow">
            <option value="" selected disabled>{{ __('select_box') }}</option>
            <option v-for="box in data.boxes" :value="box.id">
              {{ box.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="">{{ __('branding') }}</label>
          <select v-if="data.markings" v-model="marking" id="add-marking-item-select"
                  class="form-control form-control-sm with-arrow">
            <option value="" selected disabled>{{ __('add_marking') }}</option>
            <option v-for="marking in data.markings" :value="marking.id">
              {{ marking.nazwa }}
            </option>
          </select>

          <ul v-if="costs.markings" class="list-group" id="markings-list">
            <li v-for="(marking,i) in costs.markings" :key="i" class="list-group-item">
              <span class="badge" @click="removeMarking(i)"><i class="fal fa-times" aria-hidden="true"></i></span>
              {{ marking.name }}<br>
              <span style="color:#666">{{ price(marking.cost) }}/{{ __('item') }}, {{ marking.time }} {{
                  __('day(s)')
                }}</span>
              <span style="color:red; font-weight:bold;" v-if="marking.comment">{{marking.comment}}</span>
            </li>
          </ul>
        </div>
        <!--  Country / Delivery  -->
        <div class="form-group">
          <label for="">{{ __('delivery') }}</label>
          <select
              v-model="delivery"
              id="delivery_id"
              name="delivery_id"
              class="form-control form-control-sm with-arrow"
          >
            <option value="">-</option>
            <option v-for="delivery in data.deliveries" :value="delivery.id">
              {{ delivery.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input id="own_courier" type="checkbox" v-model="ownCourier" value="true" class="form-check-input">
            <label class="form-check-label" for="own_courier">
              {{ __('with_your_courier') }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group" v-if="calculated">
        <label for="">{{ __('summary') }}</label>
        <ul class="add-to-offer__summary">
          <li><b>{{ __('item_price') }}:</b> {{ price(costs.price) }}</li>
          <li v-if="costs.marking_cost"><b>{{ __('item_price_with_branding') }}:</b>
            {{ price(costs.product_price_with_branding) }}
          </li>
          <template v-if="costs.delivery">
            <li><b>{{ __('transport_cost') }}:</b> {{ price(costs.delivery.cost) }}</li>
            <li><b>{{ __('courier') }}:</b> {{ costs.delivery.courier }}</li>
            <li v-if="costs.delivery.pallets"><b>{{ __('pallets') }}:</b> {{ costs.delivery.pallets }}</li>
            <li><b>{{ __('boxes') }}:</b> {{ costs.delivery.cartoons }}</li>
            <li v-if="costs.delivery.comment"><b>{{ __('comment') }}:</b> {{ costs.delivery.comment }}</li>
            <li v-if="costs.delivery.info"><b>{{ __('comment') }}:</b> {{ costs.delivery.info }}</li>
            <li><b>{{ __('estimated_delivery_time') }}:</b> {{ costs.delivery.time }} {{ __('days') }}</li>
          </template>
          <li><b>{{ __('total') }}:</b> {{ price(costs.sum_price) }}</li>
        </ul>
      </div>
    </div>
    <div class="alert alert-primary" style="color:#000; line-height:1.1">
      {{ minimumQuantityForBranding }}
    </div>
    <div v-if="__('info_above') != 'info_above'" class="alert alert-danger">
      {{ __('info_above') }}
    </div>
    <div class="form-group" style="margin-top: 20px;">
      <button
          @click="add()"
          :disabled="loading"
          type="button"
          class="btn btn-success btn-lg btn-block">
        {{ __('add_to_offer') }}
      </button>
    </div>
    <div class="alert alert-warning" style="color:#000; line-height:1.1">
      <small>{{ __('delivery_info') }}</small>
    </div>
    <div class="modal fade" id="modalAskForName" role="dialog">
      <div class="modal-dialog modal-sm" style="color: #333333">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ __('create_new_offer') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" style="margin: 0;">
              <label>{{ __('offer_name') }}:</label>
              <input type="text" v-model="offer_name" id="offer-name" name="offer-name"
                     class="form-control" style="border: 1px solid #ccc; box-shadow: none;">
            </div>
          </div>
          <div class="modal-footer">
            <button
                @click="submit()"
                :disabled="loading"
                type="button"
                class="btn btn-outline-primary">
              {{ __('create_btn') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

</template>

<script>
import {request} from "../utils/request.js";
import {filtersToUrl, buildAppUrl, buildWooUrl} from "../utils/utils.js";

window.tlumacz = [];
export default {
  components: {},
  props: {
    productId: {
      type: Number,
      default: 0
    },
    translates: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      isLoggedIn: false,
      calculated: false,
      currency: '',
      lastOffers: [],
      loading: false,
      data: {},
      offer: 'new_offer',
      marking: '',
      selectedMarkings: [],
      delivery: '',
      box: '',
      ownCourier: false,
      costs: {},
      total: 0,
      transportCost: 0,
      itemPrice: 0,
      qty: 100,
      offer_name: ''
    };
  },
  async created() {
  },
  watch: {
    marking: async function (val) {
      if (val) {
        if (this.data.min_qty_branding > this.qty) {
          let minQty = this.data.min_qty_branding;
          alert(this.__('minimum_quantity_for_branding').replace("{qty}", minQty));
          this.marking = '';
          return;
        }

        this.selectedMarkings.push(val);
        this.marking = '';
        await this.calculate();
      }
    },
    qty: async function (val) {
      if (val < this.data.min_qty_products) {
        this.qty = 10;
      } else {
        await this.calculate();
      }
    },
    delivery: async function (val) {
      await this.calculate();
    },
    ownCourier: async function (val) {
      await this.calculate();
    }
  },
  async mounted() {
    const user = Reitergroup.getUserData();
    if (user) {
      await this.fetchData()
      //await this.calculate();
      this.offer_name = this.__('new_offer') + " " + this.getCurrentDate();
    }
  },
  computed: {
    minimumQuantityForBranding() {
      return this.__('minimum_quantity_for_branding').replace("{qty}", this.data.min_qty_branding)
    }
  },
  methods: {
    async removeMarking(el) {
      this.selectedMarkings = this.selectedMarkings.filter((val, index) => index !== el);
      await this.calculate();
    },
    price(val) {
      if (this.currency === 0) {
        return '€' + val;
      }

      if (this.currency === 1) {
        return val + 'zł';
      }
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    async fetchData() {
      this.startLoading()
      this.data = await request('offers/api/add-to-offer-data/?id=' + this.productId);
      if (this.data.status !== 'not_logged') {
        this.isLoggedIn = true;
        this.currency = parseInt(this.data.currency);
      }

      this.stopLoading()
    },
    async add() {
      if (this.offer == 'new_offer') {
        //this.offer_name = this.__('Offer ') + this.getCurrentDate();
        jQuery('#modalAskForName').modal('show')
      } else {
        this.submit();
      }
    },
    getCurrentDate() {
      return new Date().toJSON().slice(0, 10)
    },
    async submit() {
      jQuery('#modalAskForName').modal('hide');

      let result = await request('offers/api/add-product2', {
        method: 'post',
        body: JSON.stringify({
          offer_id: this.offer,
          offer_name: this.offer_name,
          product_id: this.productId,
          markings: this.selectedMarkings,
          delivery: this.delivery,
          qty: this.qty,
          box: this.box,
          own_courier: this.ownCourier,
        })
      })

      if (result && this.offer === 'new_offer') {
        this.lastOffers.push({
          id: result.id,
          name: result.name
        })

        this.offer = result.id;
      }

      Reitergroup.openOfferPreview(result.id);
      jQuery("html, body").animate({scrollTop: 0}, 600);
    },
    async calculate() {
      this.costs = await request('offers/api/total-costs2', {
        method: 'post',
        body: JSON.stringify({
          product_id: this.productId,
          markings: this.selectedMarkings,
          delivery: this.delivery,
          qty: this.qty,
          own_courier: this.ownCourier,
        })
      });

      this.calculated = true;
    },
    __(txt) {
      if (this.translates[txt]) {
        return this.translates[txt];
      }

      return txt;
    }
  }
};

</script>
